import type { FundDataWithType } from "@hsl/fund-explorer/metaSchemas";

import { Translate } from "../../hooks/useTranslation";
import useExplorerStore from "../../store/store";
import Tabs, { type Tab } from "../Tabs";
import {
    AdditionalDocumentsSection,
    DownloadsSection,
    KeyDocumentsSection,
} from "./components";
import { DocumentContextProvider } from "./context";

const TABS = [
    { key: "key-documents", label: <Translate>Key documents</Translate> },
    {
        key: "additional-documents",
        label: <Translate>Additional documents</Translate>,
    },
];

export function createDocumentsTabContent(tab: Tab, fund: FundDataWithType) {
    switch (tab.key) {
        case "key-documents":
            return <KeyDocumentsSection fund={fund} />;
        case "additional-documents":
            return <AdditionalDocumentsSection />;
        default:
            return <></>;
    }
}

export interface Props {
    fund: FundDataWithType;
    hasUpdates?: (x: string | number) => boolean;
    markRead?: (x: string | number) => void;
}

/**
 * !!!
 *  Remove dummy data and add relevant parts to the config
 *  !!!
 */
const FundCardDocuments = ({ fund, hasUpdates, markRead }: Props) => {
    const {
        audienceId: audience,
        languageId: language,
        productType,
    } = useExplorerStore((state) => state.config);
    const share_classes = fund.data.share_classes;
    const isPMC = productType === "pmc";
    return (
        <DocumentContextProvider
            params={{ audience, language, share_classes }}
            fund={fund}
            hasUpdates={hasUpdates}
            markRead={markRead}
        >
            {isPMC ? (
                <KeyDocumentsSection className="mt-2 sm:mt-4" fund={fund} />
            ) : (
                <Tabs
                    withBorder
                    tabs={TABS}
                    content={(TABS as Tab[]).map((tab) =>
                        createDocumentsTabContent(tab, fund),
                    )}
                    tabClassName="mr-12 mt-1"
                    contentContainerClassName="pt-4"
                />
            )}
            <DownloadsSection fund={fund} />
        </DocumentContextProvider>
    );
};

export default FundCardDocuments;
